import { createAction } from 'utils/redux'

export const fetchConversationsData = createAction('FETCH_CONVERSATIONS_DATA')
export const fetchConversationsDataSuccess = createAction(
  'FETCH_CONVERSATIONS_DATA_SUCCESS'
)
export const fetchConversationsDataFailed = createAction(
  'FETCH_CONVERSATIONS_DATA_FAILED'
)
export const fetchConversationsDataPending = createAction(
  'FETCH_CONVERSATIONS_DATA_PENDING'
)

export const exportConversationData = createAction('EXPORT_CONVERSATION_DATA')
export const exportAllConversationData = createAction(
  'EXPORT_ALL_CONVERSATION_DATA'
)
export const exportConversationDataSuccess = createAction(
  'EXPORT_CONVERSATION_DATA_SUCCESS'
)
export const exportConversationDataFailed = createAction(
  'EXPORT_CONVERSATION_DATA_FAILED'
)

export const fetchAvailabilityData = createAction('FETCH_AVAILABILITY_DATA')
export const fetchAvailabilityDataPending = createAction(
  'FETCH_AVAILABILITY_DATA_PENDING'
)
export const fetchAvailabilityDataFailed = createAction(
  'FETCH_AVAILABILITY_DATA_FAILED'
)
export const fetchAvailabilityDataSuccess = createAction(
  'FETCH_AVAILABILITY_DATA_SUCCESS'
)
